import { render, staticRenderFns } from "./CreateCase.vue?vue&type=template&id=ed0ce2ca&scoped=true&"
import script from "./CreateCase.vue?vue&type=script&lang=js&"
export * from "./CreateCase.vue?vue&type=script&lang=js&"
import style0 from "./CreateCase.vue?vue&type=style&index=0&id=ed0ce2ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0ce2ca",
  null
  
)

export default component.exports